import {useState,useEffect} from 'react'
import useCurrentUser from '../../hooks/useCurrentUser'
import {envAwarePost,copyToClipboard} from '../../util/util'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import {
	FacebookIcon,FacebookShareButton,
	TwitterIcon,TwitterShareButton,
	LinkedinIcon,LinkedinShareButton,
} from 'react-share'

const Referrals = ()=>{
	const user = useCurrentUser()

	const [referralLinkStatus,setReferralLinkStatus] = useState('idle')

    const getReferralLink = async ()=>{
        setReferralLinkStatus('pending')

        const res = await envAwarePost(
        	'api/referrals/', 
        	{action:'getSecureReferallLink'}
        )

        if (res.success === '1') {
            copyToClipboard(res.data.link)
            setReferralLinkStatus('copied')
            setTimeout(()=>{
                setReferralLinkStatus('idle')
            },1500)
        }else{ 
            setReferralLinkStatus('idle')
            window.alert(res.message)
        }
    }
    const [referralListStatus,setReferralListStatus] = useState('idle')
    const [referralList,setReferralList] = useState([])
    
    const getReferralList = async ()=>{
        setReferralListStatus('pending')
        const res = await envAwarePost('api/referrals/',{action:'getReferrals'})
        if (res.success === '1') {
            setReferralList(res.data.referrals)
            setReferralListStatus('idle')
        }else{ 
            setReferralListStatus('idle')
            window.alert(res.message)
        }
    }

    const [facebookLink,setFacebookLink] = useState('')
    const getFacebookLink = async ()=>{
    	const res = await envAwarePost('api/referrals/',{action:'getSecureReferallLink'})
    	if (res.success === '1') {
            setFacebookLink(res.data.link)
        }else{ 
            setReferralLinkStatus('idle')
            window.alert(res.message)
        }
    }

    const [twitterLink,setTwitterLink] = useState('')
    const getTwitterLink = async ()=>{
    	const res = await envAwarePost('api/referrals/',{action:'getSecureReferallLink'})
    	if (res.success === '1') {
            setTwitterLink(res.data.link)
        }else{ 
            window.alert(res.message)
        }
    }

    useEffect(async ()=>{
    	getReferralList()
    	getFacebookLink()
    	getTwitterLink()
    },[])

    const handleEmailLink = async ()=>{
    	const res = await envAwarePost('api/referrals/',{action:'getSecureReferallLink'})
        if (res.success === '1') {
            const link = encodeURIComponent(res.data.link)
            const subject = 'Awesome software for Personal Trainers'
	    	const body = `Check out this super helpful software for personal trainers. It makes managing my clients and planning / delivering fitness programs much easier. It has great messaging capabilities (group, 1:1, automated, and scheduled messages) and lets both me and my clients see their progress through automated progress tracking.  I can also sell personal training services and merchandise through it. I thought you might find it helpful. \n Access the following link: \n\n${link}`
	    	window.location = `mailto:?subject=${subject}&body=${body}`
        }else{ 
            setReferralLinkStatus('idle')
            window.alert(res.message)
        }	
    }

	return (
		<div className="pt-3 px-2 px-md-3 mb-3">
			<div>
				<strong className="d-block">Refer and Earn</strong>
				<div>Earn $100s or even $1000s just by letting other trainers know about FitSW</div>
			</div>
			<div className="mb-3 my-4">
				<div className="mb-1">
					Referral Link Share Options
				</div>
				<div className="d-flex align-items-center">
					<ButtonGroup className="mr-2" size="sm">
						<Button 
							disabled={referralLinkStatus==='pending'}
							onClick={getReferralLink} 
							variant="outline-primary" 
							size="sm"
						>
							{referralLinkStatus==='copied'?'Copied!':'Copy Referral Link'} {referralLinkStatus==='pending'&&<Spinner animation="border" size="sm"/>}
						</Button>
						<Button 
							variant="outline-dark" 
							size="sm"
							onClick={handleEmailLink}
						>
							Email Referral Link
						</Button>
					</ButtonGroup>
					<OverlayTrigger overlay={
						<Tooltip>Click a social icon to share referral link</Tooltip>
					}>
						<div className="p-1">
							{/* Facebook share button */}
							<FacebookShareButton 
								className="mr-1"
								quote="Check out this awesome software for Personal Trainers"
								url={facebookLink}
								//links are single use so refresh after share
								onClick={getFacebookLink}
								hashtag="#fitsw"
							>
								<FacebookIcon size={32} round={true}/>
							</FacebookShareButton>
							{/* Twitter share button */}
							<TwitterShareButton 
								className="mr-1"
								title="Check out this awesome software for Personal Trainers"
								url={twitterLink}
								//links are single use so refresh after share
								onClick={getTwitterLink}
								hashtags={["fitsw","personaltraining","fitnesscoach"]}
								related={["fitsw"]}
							>
								<TwitterIcon size={32} round={true}/>
							</TwitterShareButton>
						</div>
					</OverlayTrigger>
				</div>
			</div>
			<p>
				For every trainer that you refer you will earn between 15%-35% of their subscription fees for the first year.  So if you refer 5 trainers that could be ~$300 or 10 could be $650. The more you refer the more you earn. You can either choose direct payouts or just apply your referral earnings to a custom app or your subscription. Your referrals will be tracked right here on this page, easy for you to see. <a href="/referralDetails/"> Additional details</a>.
			</p>
			<div className="mt-2 mb-3">
				Your Referrals
			</div>
			<div>
				{
					referralListStatus==='pending' ? 
					<Spinner animation="border" size="sm"/> :
					<div>
						{referralList.map(({referred_user:{user_name,sign_up_date}})=>(
							<div className="p-2 border rounded mb-1 d-flex flex-wrap">
								<div style={{overflowWrap: 'break-word'}}>{user_name}</div>
								<div className="ml-auto">
									<small className="text-muted">
										Referral date: {(new Date(sign_up_date?.split(' ').join('T'))).toLocaleDateString()}
									</small>
								</div>
							</div>
						))}
					</div>
				}
			</div>
		</div>
	)
}

export default Referrals